// Imports
import ItemsRoutes from "./ItemsRoutes";

export default [...ItemsRoutes];
